import { AnyAction } from '@reduxjs/toolkit'
import * as types from 'model/actionTypes'
import { DictT, PriceT } from 'shared/types/model'

const initialState: DictT<PriceT> | null = null

export default function (
  state = initialState,
  action: AnyAction
): typeof initialState {
  switch (action.type) {
    case types.RECEIVE_PRICES:
      return action.prices
    case types.CLEAR:
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}
